import React from 'react'
import useTabParam from '../../hooks/useTabParam'
import { Box, Typography } from '@mui/material'
import PageTitle from '../../components/PageTitle'
import { Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined'
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined'
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined'
import AuditLogsTab from '../../components/audit/tabs/AuditLogsTab'
import LoginPasswordTab from '../../components/audit/tabs/LoginPasswordTab'
import ShipmentsTab from '../../components/audit/tabs/ShipmentsTab'
import MerchantReportsTab from '../../components/audit/tabs/MerchantReportsTab'
import PiiAccessTab from '../../components/audit/tabs/PiiAccessTab'
import SecurityAuditTab from '../../components/audit/tabs/SecurityAuditTab'

function AuditTrails() {
  const [value, setValue] = useTabParam('1')

  const handleChange = (_event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box>
      <PageTitle>Audit Trails</PageTitle>
      {/* Page Header */}
      <Box
        sx={{
          px: 3,
          py: 2.5,
          background: 'linear-gradient(135deg, #1b1b28 0%, #1e3a5f 100%)',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: 2,
            bgcolor: 'rgba(255,255,255,0.12)',
            border: '1px solid rgba(255,255,255,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <ManageSearchOutlinedIcon sx={{ color: '#fff', fontSize: 26 }} />
        </Box>
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)' }}>
          Track all system activity — logins, config changes, shipments, reports, PII access &amp; API security
        </Typography>
      </Box>

      {/* Tabs */}
      <TabContext value={value}>
        <Box sx={{ backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', position: 'sticky', top: 0, zIndex: 10 }}>
          <TabList
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTab-root': {
                px: 3,
                py: 1.75,
                fontWeight: 500,
                fontSize: '13px',
                minHeight: 52,
                gap: 0.5,
                transition: 'background 0.2s',
                '&:hover': {
                  bgcolor: 'rgba(25,118,210,0.04)',
                },
              },
              '& .Mui-selected': {
                fontWeight: 700,
              },
            }}
          >
            <Tab icon={<ManageSearchOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Audit Logs" value="1" />
            <Tab icon={<HistoryOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Login History" value="2" />
            <Tab icon={<LockResetOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Password Changes" value="3" />
            <Tab icon={<LocalShippingOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="B2C Shipments" value="4" />
            <Tab icon={<AssessmentOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Merchant Reports" value="5" />
            <Tab icon={<VisibilityOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="PII Access" value="6" />
            <Tab icon={<SecurityOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="API Security" value="7" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{ px: 0, pt: 2.5, bgcolor: '#f5f6fa', minHeight: '70vh' }}>
          <AuditLogsTab />
        </TabPanel>
        <TabPanel value="2" sx={{ px: 0, pt: 2.5, bgcolor: '#f5f6fa', minHeight: '70vh' }}>
          <LoginPasswordTab view="login" />
        </TabPanel>
        <TabPanel value="3" sx={{ px: 0, pt: 2.5, bgcolor: '#f5f6fa', minHeight: '70vh' }}>
          <LoginPasswordTab view="password" />
        </TabPanel>
        <TabPanel value="4" sx={{ px: 0, pt: 2.5, bgcolor: '#f5f6fa', minHeight: '70vh' }}>
          <ShipmentsTab />
        </TabPanel>
        <TabPanel value="5" sx={{ px: 0, pt: 2.5, bgcolor: '#f5f6fa', minHeight: '70vh' }}>
          <MerchantReportsTab />
        </TabPanel>
        <TabPanel value="6" sx={{ px: 0, pt: 2.5, bgcolor: '#f5f6fa', minHeight: '70vh' }}>
          <PiiAccessTab />
        </TabPanel>
        <TabPanel value="7" sx={{ px: 0, pt: 2.5, bgcolor: '#f5f6fa', minHeight: '70vh' }}>
          <SecurityAuditTab />
        </TabPanel>
      </TabContext>
    </Box>
  )
}

export default AuditTrails
